var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedirectIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 11,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 18,
    height: 2,
    rx: 1,
    fill: "#6F6F6F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 2,
    height: 18,
    rx: 1,
    fill: "#6F6F6F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 10,
    width: 2,
    height: 10,
    rx: 1,
    fill: "#6F6F6F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 10,
    height: 2,
    rx: 1,
    fill: "#6F6F6F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 12.1319,
    height: 1.98351,
    rx: 0.991755,
    transform: "matrix(0.701061 -0.713101 0.725116 0.688627 9 9.6341)",
    fill: "#6F6F6F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    width: 9,
    height: 1.96569,
    rx: 0.982847,
    fill: "#6F6F6F"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 2,
    rx: 1,
    transform: "matrix(0.0032206 0.999995 -0.999996 0.00267217 20 0)",
    fill: "#6F6F6F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirectIcon);
export default __webpack_public_path__ + "static/media/redirectIcon.1fa4f577b42a4d4981ec95bbcf257b24.svg";
export { ForwardRef as ReactComponent };